
define('app/board/collections/queueCollection',[
	'jquery',
	'underscore',
	'backbone',
	'app/board/models/queueItemModel'
], function($, _, Backbone, QueueItemModel){
	var QueueCollection = Backbone.Collection.extend({
		model : QueueItemModel,
		
		initialize: function(models, options) {
			this.lgInstId = options.lgInstId;
			this.backedUpQueue = [];
			
			
			_.bindAll(this, 'playerPicked');
			
			$(document).on('draftApp:playerPicked', this.playerPicked);
			
			this.on('change', this.saveLocalStorage, this);
			this.on('add', this.saveLocalStorage, this);
			this.on('remove', this.saveLocalStorage, this);
	    },
	    
	    loadData: function(playerList) {
	    	this.playerList = playerList;
	    	if(typeof localStorage !== 'undefined' && localStorage.getItem(this.lgInstId + ":queue")){
	    		var queueJson = JSON.parse(localStorage.getItem(this.lgInstId + ":queue"));
	    		
	    		//Load only found players that haven't been drafted yet
	    		if(queueJson && queueJson.length > 0){
	    			for(var i=0; i<queueJson.length; i++){
	    				queueItem = queueJson[i];
	    				var foundPlayer = this.playerList.findPlayerByDraftPlayerId(queueJson[i].id);
	    				var allowed = foundPlayer != null ? !foundPlayer.drafted : false;
	    				if(allowed){
	    					this.add(queueItem);
	    				}
	    			}
	    		}
	    	}
	    	
	    	for(var i=0; i<this.backedUpQueue.length; i++){
	    		this.playerPicked(null, this.backedUpQueue[i]);
	    	}
	    	
	    	this.backedUpQueue = [];
	    },
	    
	    saveLocalStorage: function(){
	    	if(typeof localStorage !== 'undefined' && $.isLocalStorageSaveSupported()){
	    		localStorage.setItem(this.lgInstId + ":queue", JSON.stringify(this.toJSON()));
	    		
	    		//var savedColors = this.toJSON();    		
	    		//localStorage.setItem("posColors", JSON.stringify(savedColors));
	    	}
	    },
	    
	    playerPicked: function(event, playerId) {
	    	if(this.playerList){
	    		var player = this.playerList.findPlayerByPlayerId(playerId);
	    		if(player && this.get(player.draftablePlayerId)){
		    		var queueItem = this.get(player.draftablePlayerId);
		    		this.remove(queueItem);
		    	}
	    	} else {
	    		this.backedUpQueue.push(playerId);
	    	}    	
	    }
	});
	
	return QueueCollection;  
});